import { MigrationSource } from '../migration-reusable-components/migration-source.enum';

export class LoadProduct {

	/**
	 * Class name of the component that needs to be loaded
	 */
	component: any;

	/**
	 * Value that's going be used to sent as HTTP param to migration-orchestrator to filter results.
	 */
	migrationSource: MigrationSource;

	/**
	 * For certain products (example FileCabinet CS, user will be redirected to new URL),
	 * customer's may be redirected to new url
	 */
	urlToRedirect: string;

	constructor(component: any, migrationSource: MigrationSource, urlToRedirect?: string) {
		this.component = component;
		this.migrationSource = migrationSource;
		this.urlToRedirect = urlToRedirect;
	}
}
